/**
 * Fenêtre de réponse Meta (24 h) côté interface — Lot 3.1 (2026-09-03).
 * Miroir de services/inbound/window.ts côté API : l'interface n'invente rien,
 * elle empêche seulement de proposer un envoi qui serait refusé.
 */
export const REPLY_WINDOW_MS = 24 * 3_600_000;

export function windowOpenUntil(from: string | null | undefined): Date | null {
  if (!from) return null;
  const t = new Date(from).getTime();
  return Number.isFinite(t) ? new Date(t + REPLY_WINDOW_MS) : null;
}

export function isWindowOpen(from: string | null | undefined, now: Date = new Date()): boolean {
  const until = windowOpenUntil(from);
  return !!until && until.getTime() > now.getTime();
}

/** « jusqu'à 18:32 » — repère court pour le membre. */
export function windowLabel(from: string | null | undefined, lang: string): string {
  const until = windowOpenUntil(from);
  if (!until) return '';
  return until.toLocaleTimeString(lang, { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Brussels' });
}
